import { ItCheckboxGroupBase } from './it-checkbox-group-base.js';
import '../index-Cj8LeLRC.js';
import 'lit/directive.js';
import 'lit';
import 'lit/decorators.js';
import 'lit/directives/when.js';
import 'lit/directives/if-defined.js';

/**
 * @element it-checkbox-group
 */
class ItCheckboxGroup extends ItCheckboxGroupBase {
}
if (!customElements.get('it-checkbox-group')) {
    customElements.define('it-checkbox-group', ItCheckboxGroup);
}

export { ItCheckboxGroup };
//# sourceMappingURL=it-checkbox-group.js.map
